import {useCallback} from 'react';
import {IVodItemFragmentFragment} from '@src/Api/Graphql/gql/types.generated';
import {Routes} from '@src/Constant/routes';
import useAppNavigation from '@src/utils/useAppNavigation';
import {useFindProgression} from '@src/Hooks/useFindProgression';

export function useVodTrailer() {
  const navigation = useAppNavigation();
  const {findCurrentTime} = useFindProgression();

  const openTrailer = useCallback(
    (item: IVodItemFragmentFragment) => () => {
      if (item.trailer) {
        let time = findCurrentTime(item.id);
        navigation.navigate(Routes.WATCH, {
          state: {
            params: {
              type: 'player',
              liveEventId: item.trailer,
              source: 'vimeo',
              title: item.name || '',
              url: item.url || '',
              videoId: item.id,
              time,
              paywallData: {
                accessType: item.accessType,
                paywall: item.paywall,
              },
              id: item.id || '',
              previousScreen: 'content',
            },
          },
        });
      }
    },
    [navigation, findCurrentTime],
  );

  return {openTrailer};
}
